import { Icon, List, Text } from '@dixa/lib-shared-habla';
import { LanguageEvaluationResult } from 'lib-shared-types-api';

import { getLanguageStatusText, getStatusIndicator } from '../../utils';

type LanguageEvaluationListProps = {
  languageEvaluations: readonly LanguageEvaluationResult[];
};

/** Displays a list of language evaluation results with status icons. */
export const LanguageEvaluationList = ({
  languageEvaluations,
}: LanguageEvaluationListProps): JSX.Element => {
  return (
    <List>
      {languageEvaluations.map((lang) => {
        const { icon, color } = getStatusIndicator(lang.kind);
        const langText = getLanguageStatusText(lang.kind);

        return (
          <List.Item
            key={lang.language}
            contentLeft={<Icon name={icon} size={16} color={color} />}
            title={
              <Text.Paragraph variant="3" subdued>
                {lang.language.toUpperCase()} · {langText}
              </Text.Paragraph>
            }
          />
        );
      })}
    </List>
  );
};
